import PropTypes from 'prop-types';
export var Modifiers;
(function (Modifiers) {
    Modifiers["FontBold"] = "font-weight.bold";
    Modifiers["FontOblique"] = "font-style.oblique";
    Modifiers["FontItalic"] = "font-style.italic";
    Modifiers["ColorBrand"] = "color.brand";
    Modifiers["ColorSale"] = "color.sale";
})(Modifiers || (Modifiers = {}));
export var ItemShape = {
    /** Navigation item display name. */
    name: PropTypes.string,
    /** Link to redirect, only if navigation item is a leaf */
    href: PropTypes.string,
    /** Custom HTML to display in navigation item. */
    html: PropTypes.string,
    /** Optional link modifiers for customizing navigation item styles. */
    modifiers: PropTypes.arrayOf(PropTypes.oneOf([
        Modifiers.FontBold,
        Modifiers.FontOblique,
        Modifiers.FontItalic,
        Modifiers.ColorBrand,
        Modifiers.ColorSale,
    ])),
    children: PropTypes.any,
};
/**
 * Children navigation items list.
 * If navigation item is a leaf this prop should be an empty array.
 */
ItemShape.children = PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.shape(ItemShape)));
export var ItemPropType = PropTypes.shape(ItemShape);
